/**
 * useWorkforceTelemetry — thin React-side recorder for the workforce
 * workspace. Stable identity, no useCallback ceremony required at the
 * call site, fire-and-forget on every dispatch.
 */

import { useCallback } from 'react';
import { recordEvent as recordEventInClient } from '../services/workforceTelemetryClient';

export function useWorkforceTelemetry() {
  const recordEvent = useCallback((event) => {
    try {
      recordEventInClient(event);
    } catch {
      /* never break the host page */
    }
  }, []);

  return { recordEvent };
}

export default useWorkforceTelemetry;
